import React, { useState } from "react";
import Typical from "react-typical";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

import imgBack from "../../images/mailz.jpeg";
import load1 from "../../images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (name.length === 0 || email.length === 0 || message.length === 0) {
      setBanner("Please fill all the fields!");
      toast.error("Please fill all the fields!");
      return;
    }

    try {
      setBool(true);

      const templateParams = {
        name: name,
        email: email,
        message: message,
        title: `Portfolio Message from ${name}`,
      };

      // IMPORTANT: Replace these with your actual EmailJS credentials
      // Sign up at https://www.emailjs.com/
      const SERVICE_ID = "service_vtanny4";
      const TEMPLATE_ID = "template_0le7d1k";
      const PUBLIC_KEY = "zgB6zxdyW_k8knpXz";

      const res = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );

      if (res.status === 200) {
        setBanner("Thank You For Contacting Mr. Sandeep");
        toast.success("Thank You For Contacting Mr. Sandeep");
        setBool(false);
        setName("");
        setEmail("");
        setMessage("");
      }
    } catch (error) {
      console.log(error);
      setBool(false);
      toast.error("Failed to send message. Please verify EmailJS IDs.");
    }
  };

  return (
    <div className="main-container" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
            <Typical loop={Infinity} steps={["Get In Touch 📧", 1000]} />
          </h2>{" "}
          <a href="https://www.facebook.com/sandeepkumarsahoo.chandan">
            <i className="fa fa-facebook-square" />
          </a>
          <a href="https://github.com/evil-sandeep">
            <i className="fa fa-github" />
          </a>
          <a href="https://www.instagram.com/evil_sandeep/">
            <i className="fa fa-instagram" />
          </a>
          <a href="https://www.youtube.com/@sandeepkumarsahoo2274">
            <i className="fa fa-youtube-square" />
          </a>
          <a href="https://twitter.com/Sandeep88034451">
            <i className="fa fa-twitter" />
          </a>
          <a href="https://api.whatsapp.com/send?phone=919078996315">
            <i className="fa fa-whatsapp" />
          </a>
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Send Your Email Here!</h4>
            <img src={imgBack} alt="back form" />
          </div>
          <form onSubmit={submitForm}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName} value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} value={email} />

            <label htmlFor="message">Message</label>
            <textarea type="text" onChange={handleMessage} value={message} />

            <div className="send-btn">
              <button type="submit">
                send
                <i className="fa fa-paper-plane" />
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="loading" />
                  </b>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
